module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_8011.26be4ecc.png";